import React, { useState,useEffect } from 'react';
import { dynamicUrl,DownloadFile } from './Function';
import PlacementCounters from './PlacementCounters'
import { Card,Row,Col,Placeholder, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const Placements = ({pageData}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByTypeLatest = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeLatest/15");
                const result = await response.json();
                setMiscellaneous(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeLatest : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeLatest : Error', error.message);
            }
        };
        MiscellaneousByTypeLatest();
    },[pageData])
    
    return (
        <React.Fragment>
        {pageData.sp_detail && <div dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? pageData.sp_detail_hi || pageData.sp_detail : pageData.sp_detail}} />}
        <Card className=' mb-4 text-center'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'प्लेसमेंट वीडियो' : 'Placement VIDEOS'}
            </Card.Header>
            <Card.Body>
            {isLoading ? (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                {[...Array(6)].map((_,index)=>(
                    <Col key={index}>
                        <div className="ratio ratio-4x3 border border-4 rounded" data-aos="flip-up" data-aos-duration="1000">
                            <Placeholder className="w-100 h-100" />
                        </div>
                    </Col>
                ))}
                </Row>
                ) : (
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                {Miscellaneous.slice(0, 6).map((sm,index)=>(
                    <Col key={index}>
                        <div className="ratio ratio-4x3 border border-4 rounded overflow-hidden" data-aos="flip-up" data-aos-duration="1000">
                            <iframe src={sm.sm_link+'?rel=0&cc_load_policy=1'} title={sm.sm_nmae} allowFullScreen></iframe>
                        </div>
                    </Col>
                ))}
                </Row>
            )}
                <MoreButton spId={205} Name={appLanguage === 'hi' ? 'और भी वीडियो' : 'MORE VIDEOS'} />            
            </Card.Body>
        </Card>
        <PlacementCounters />
        <DynamicMiscellaneous mtId={8} />
        <DynamicMiscellaneous mtId={9} />
        <PageDetails spId={204} />
        <PageDetails spId={212} />
        </React.Fragment>
    );
}
export default Placements;
const PageDetails = ({spId}) =>
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[PageDetails,setDetails]=useState([]);
    useEffect(()=>
    {
        const getPageDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"webPage/byId/"+spId);
                const result = await response.json();
                setDetails(result);
                if( global.config.IsPrint === true ) { console.info('PageDetails : Result',result); }
            
            } catch (error) 
            {
                console.error('PageDetails : Error', error.message);
            }
        };
        getPageDetails();    
    },[spId])
    return (
        <React.Fragment>
        {PageDetails.map((sp,index)=>(
            <div className='mb-4' key={index} dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? sp.sp_detail_hi || sp.sp_detail : sp.sp_detail}} />
        ))}
        </React.Fragment>
        
    );
}
const MoreButton = ({spId,Name}) => 
{
    const[Links,setLinks]=useState([]);
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        getDynamicLink();    
    },[spId,Name])
    return (
        <React.Fragment>
        {Links.map((sp,index)=>(
            <NavLink to={dynamicUrl(sp)} className='btn btn-info mt-3' key={index}>
                {Name}
            </NavLink>
        ))}
        </React.Fragment>        
    );
}
const DynamicMiscellaneous = ({mtId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneousType(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousType Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneousType([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
        };
        MiscellaneousType();
    },[mtId])
    return (
        <React.Fragment>
            {isLoading ? ( 
                <Card className=' mb-4'>
                    <Card.Header className='text-center fs-3 text-uppercase'><Placeholder xs={10} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            {[...Array(8)].map((_,index)=>(
                            <Col md={3} key={index} >
                                <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={12} style={{height:"200px"}} />
                                    <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                                        <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                                        <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ) : (
            <React.Fragment>
            {MiscellaneousType.map((mt,index)=>(
            <Card className=' mb-4 text-center' key={index}>
                <Card.Header className='text-center fs-3 text-uppercase'>
                    {appLanguage === 'hi' ? (mt.mt_display_en === "1" ? mt.mt_name_hi || '' : mt.mt_name_hi || mt.mt_name) : mt.mt_name}    
                </Card.Header>
                <Card.Body>
                    <MiscellaneousList mtId={mt.mt_id} mtImage={appLanguage === 'hi' ? mt.miscImage_hi || mt.miscImage : mt.miscImage} />
                    {mt.mt_id === 8 && <MoreButton spId={209} Name={appLanguage === 'hi' ? "और पढ़ें" : "READ MORE"} />}
                    {mt.mt_id === 9 && <MoreButton spId={210} Name={appLanguage === 'hi' ? "और पढ़ें" : "READ MORE"} />}
                </Card.Body>
            </Card>
            ))}
            </React.Fragment>
            )}
        </React.Fragment>
    );
}
const MiscellaneousList = ({mtId,mtImage}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByTypeLatest = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeLatest/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = el.upp;
                            result[i].miscFileHi = el.upb;
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Miscellaneous File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByTypeLatest : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByTypeLatest : Error', error.message);
            }
        };
        MiscellaneousByTypeLatest();   
    },[mtId,mtImage])
    return (
        <React.Fragment>
        {isLoading ? (
            <Row className='g-3'>
                {[...Array(8)].map((_,index)=>(
                <Col md={3} key={index} >
                    <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                        <Placeholder xs={12} style={{height:"200px"}} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                            <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>   
            ) : (
            <Row className='g-3'>
                {Miscellaneous.slice(0, 8).map((sm,index)=>(
                <Col md={3} key={index} >
                    <Card className="text-bg-dark text-center shadow" data-aos="flip-up" data-aos-duration="1000">
                        <Card.Img src={mtImage} alt={appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title>{appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}</Card.Title>
                            <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.miscFile,sm.miscFileHi)}} />                            
                            {sm.sm_link && 
                            <a href={sm.sm_link} target="_blank" rel="noopener noreferrer" className="btn btn-light">
                                {appLanguage === 'hi' ? "यहाँ क्लिक करें" : "Click Here"}
                            </a>}
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>
        )}
        </React.Fragment>
    );
}